export default "__VITE_ASSET__CzthVCjh__"